import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons/faArrowLeft';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'ui-components/components/button';
import { FlexRow, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import styles from './styles.module.less';

type CreateTransferOrderDrawerFooterProps = {
  isFirstStep: boolean;
  isLoading?: boolean;
  onBack: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  onNext: () => void;
  onSaveAsDraft: () => void;
};

export const CreateTransferOrderDrawerFooter = ({
  isFirstStep,
  isLoading = false,
  onBack,
  onCancel,
  onConfirm,
  onNext,
  onSaveAsDraft,
}: CreateTransferOrderDrawerFooterProps) => {
  if (isFirstStep) {
    return (
      <FlexRow gap={Gap.Space12}>
        <Button onClick={onCancel} theme={THEME_CONSTANTS.tertiary}>
          <Text textType={TextType.Caption} value={messages.cancelButton} />
        </Button>
        <Button onClick={onNext} theme={THEME_CONSTANTS.primary}>
          <Text textType={TextType.Caption} value={messages.continueButton} />
        </Button>
      </FlexRow>
    );
  }

  return (
    <FlexRow className={styles['footer-last-step']} gap={Gap.Space12}>
      <Button onClick={onBack} theme={THEME_CONSTANTS.link}>
        <FlexRow gap={Gap.Space8}>
          <FontAwesomeIcon className={styles['back-button-icon']} icon={faArrowLeft} />
          <Text textType={TextType.Caption} value={messages.backButton} />
        </FlexRow>
      </Button>
      <FlexRow gap={Gap.Space12}>
        <Button onClick={onCancel} theme={THEME_CONSTANTS.tertiary}>
          <Text textType={TextType.Caption} value={messages.cancelButton} />
        </Button>
        <Button disabled={isLoading} onClick={onSaveAsDraft} theme={THEME_CONSTANTS.secondary}>
          <Text textType={TextType.Caption} value={messages.saveAsDraftButton} />
        </Button>
        <Button disabled={isLoading} isLoading={isLoading} onClick={onConfirm} theme={THEME_CONSTANTS.primary}>
          <Text textType={TextType.Caption} value={messages.createTransferButton} />
        </Button>
      </FlexRow>
    </FlexRow>
  );
};
